<template>
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 99.5 99.5" v-bind:svg-inline="''" :class="['star', color, size, animation]" :style="position" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path d="M49.8 0C56.4 26.5 73 43.1 99.5 49.8 73 56.4 56.4 73 49.8 99.5 43.1 73 26.5 56.4 0 49.8 26.5 43.1 43.1 26.5 49.8 0z"/></svg>
</template>

<script>
import { whichAnimationEnd } from "@/lib/event-detection";
import { randomValue, randomBetween } from "@/lib/random";
import { SAFE_STAR_POSITION_RANGES } from "@/constants";

const animationEnd = whichAnimationEnd();

export default {
	name: 'StarBackdrop',
	data() {
		return {
			color: "",
			size: "",
			animation: "",
			position: "",
		};
	},
	methods: {
		getPosition() {
			const xCoordinates = randomValue(SAFE_STAR_POSITION_RANGES);
			const yCoordinates = randomValue(SAFE_STAR_POSITION_RANGES);
			const x = randomBetween(xCoordinates.min, xCoordinates.max);
			const y = randomBetween(yCoordinates.min, yCoordinates.max);
			return { top: `${x}vh`, left: `${y}vw` };
		},
		reset() {
			this.set({ color: "", size: "", animation: "", position: "" });
		},
		randomize() {
			this.set({
				color: randomValue(["white", "orange", "dark"]),
				size: randomValue(["sm", "md", "lg"]),
				animation: randomValue(["short", "med", "long"]),
				position: this.getPosition(),
			});
		},
		set({ color, size, position, animation }) {
			this.color = color;
			this.size = size;
			this.animation = animation;
			this.position = position;
		},
	},
	mounted() {
		this.randomize();
		this.$el.addEventListener(animationEnd, () => {
			this.$nextTick(() => {
				this.reset();
				this.$nextTick(() => this.randomize());
			});
		});
	},
};
</script>

<style lang="scss" scoped>
	.star {
		display: block;
		position: fixed;
		max-width: 25px;
		max-height: 25px;

		&.white { fill: $off-white; }
		&.orange { fill: $primary-color; }
		&.dark { fill: $body-txt-color; }

		&.sm { width: 1vmin; height: 1vmin; }
		&.md { width: 1.75vmin; height: 1.75vmin; }
		&.lg { width: 2.5vmin; height: 2.5vmin; }

		&.short { animation: twinkle 4s; }
		&.med { animation: twinkle 8s; }
		&.long { animation: twinkle 12s; }
	}
</style>



// WEBPACK FOOTER //
// src/components/partials/BackdropStar.vue